<template lang="pug">
  .ov-table-scroll-wrap
    // top fake horizontal scrollbar (visible only if table overflows)
    .ov-table-scroll-top(v-show="hasOverflow", ref="topScroll", @scroll="syncFromTop")
      // inner element used to match table full scroll width
      .ov-table-scroll-top-inner(ref="topInner")

    // real scroll container (table body)
    div(:class="bodyClass", ref="bodyScroll", @scroll="syncFromBody")
      slot
</template>

<script>
export default {
  name: 'OvTableScroll',

  props: {
    // wrapper class for the scrollable body
    bodyClass: {
      type: String,
      default: 'ov-table-wrapper',
    },
  },

  data() {
    return {
      hasOverflow: false, // controls visibility of top scrollbar
      syncing: false,     // prevents scroll sync loop
    };
  },

  mounted() {
    // initial calculation of scroll width
    this.updateScrollWidth();

    // observe DOM changes that may affect table width
    this.resizeObserver = new ResizeObserver(() => this.updateScrollWidth());

    // observe table size (if exists)
    const table = this.$refs.bodyScroll && this.$refs.bodyScroll.querySelector('table');
    if (table) {
      this.resizeObserver.observe(table);
    }

    // observe container resize
    this.resizeObserver.observe(this.$refs.bodyScroll);

    // handle window resize
    window.addEventListener('resize', this.updateScrollWidth);
  },

  beforeDestroy() {
    // cleanup observers and listeners
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener('resize', this.updateScrollWidth);
  },

  updated() {
    // re-measure after every render update
    this.$nextTick(() => this.updateScrollWidth());
  },

  methods: {

    updateScrollWidth() {
      const body = this.$refs.bodyScroll;
      const topInner = this.$refs.topInner;

      if (!body || !topInner) {
        return;
      }

      // calculate full scroll width of table/content
      const table = body.querySelector('table');
      const scrollWidth = table ? table.scrollWidth : body.scrollWidth;

      // sync fake scrollbar width with real content
      topInner.style.width = `${scrollWidth}px`;

      // show top scrollbar only if content overflows
      this.hasOverflow = scrollWidth > body.clientWidth + 1;
    },

    syncFromTop() {
      if (this.syncing) {
        return;
      }

      // sync top scrollbar -> table scroll position
      this.syncing = true;
      this.$refs.bodyScroll.scrollLeft = this.$refs.topScroll.scrollLeft;
      this.syncing = false;
    },

    syncFromBody() {
      if (this.syncing) {
        return;
      }

      // sync table scroll -> top scrollbar
      this.syncing = true;
      this.$refs.topScroll.scrollLeft = this.$refs.bodyScroll.scrollLeft;
      this.syncing = false;
    },
  },
};
</script>